import MyPortfolioProjectsPage from "@Quest/Projects/Pages/MyPortfolioProjectsPage.vue";

export const routes = [

    {
        path: "/my-projects/list/:workspaceId/:tchProjectId",
        component: MyPortfolioProjectsPage
    },
]
